module.exports = __webpack_public_path__ + "static/img/partner_XIV.2d0e5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XIV.png
// module id = JWlS
// module chunks = 9